import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { USidebarComponent } from './u-sidebar.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { UButtonModule } from '../u-button/u-button.module';

@NgModule({
  declarations: [USidebarComponent],
  imports: [CommonModule, FormsModule, MatSidenavModule, MatIconModule, UButtonModule],
  exports: [USidebarComponent],
})
export class USidebarModule {}
